import React from 'react';
import ReactDOM from 'react-dom/client';
// import * as Sentry from '@sentry/react'; // Temporarily disabled — @sentry packages not installed
import App from './App.jsx';
import './styles/global.css'; // Import global styles here

// Sentry.init({
//   dsn: import.meta.env.VITE_SENTRY_DSN,
//   sendDefaultPii: true,
//   integrations: [Sentry.replayIntegration()],
//   replaysSessionSampleRate: 0.0,
//   replaysOnErrorSampleRate: 1.0,
// });

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
